module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.close(_vm.alert, true)
      }
    }
  }, [(_vm.alert.data.status === 'added') ? _c('a', [_vm._v(" Locadora " + _vm._s(_vm.companyName) + " "), _c('span', {
    staticClass: "text-danger bold"
  }, [_vm._v(" ADICIONOU")]), _vm._v(" o cliente " + _vm._s(_vm.alert.data.client.document) + " no Painel de Alerta! ")]) : _vm._e(), _vm._v(" "), (_vm.alert.data.status === 'updated') ? _c('a', [_vm._v(" Locadora " + _vm._s(_vm.companyName) + " "), _c('span', {
    staticClass: "text-danger bold"
  }, [_vm._v("ATUALIZOU ")]), _vm._v(" o motivo do bloqueio do cliente " + _vm._s(_vm.alert.data.client.document) + " no Painel de Alerta! ")]) : _vm._e(), _vm._v(" "), (_vm.alert.data.status === 'removed') ? _c('a', [_vm._v(" Locadora " + _vm._s(_vm.companyName) + " "), _c('span', {
    staticClass: "text-success bold"
  }, [_vm._v("REMOVEU")]), _vm._v(" o cliente " + _vm._s(_vm.alert.data.client.document) + " no Painel de Alerta! ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.alert.data.status === 'removed') ? _c('span', [_vm._v("\n\t\t\t\tMotivo: "), _c('strong', [_vm._v(" " + _vm._s(_vm.alert.data.solution) + " ")])]) : _c('span', [_vm._v("\n\t\t\t\tMotivo: "), _c('strong', [_vm._v(" " + _vm._s(_vm.alert.data.reason) + " ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    on: {
      "click": function($event) {
        return _vm.close(_vm.alert)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "space-50"
  }), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.alert.date)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78ecede0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/general_notification_components/AlertPanelNotification.vue
// module id = 839
// module chunks = 2